import React, { useEffect } from "react";
import { DeleteConfirmationModalProps } from "./types";

export default function DeleteConfirmationModal({
  onConfirm,
  onCancel,
  loading,
  entityName,
  entityType,
}: Readonly<DeleteConfirmationModalProps>) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 grid place-items-center bg-black/40 backdrop-blur-[2px]"
    >
      <div className="bg-white rounded-md p-6 w-[400px] shadow-lg text-center">
        <h3 className="text-[16px] font-medium text-[#2B2B2B] mb-6">
          Do you really want to delete{" "}
          {entityName ? <span className="font-bold">{entityName}</span> : null}{" "}
          {entityType === "msp" ? "MSP" : "Customer"}?
        </h3>

        <div className="flex justify-center gap-4">
          <button
            onClick={onCancel}
            disabled={loading}
            className={`w-[100px] py-2 rounded-md bg-[#E0E0E0] text-[#2B2B2B] font-medium hover:bg-[#D6D6D6] ${
              loading ? "opacity-60 cursor-not-allowed" : ""
            }`}
          >
            NO
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className={`w-[100px] py-2 rounded-md bg-[#0066FF] text-white font-medium hover:bg-[#0052CC] ${
              loading ? "opacity-60 cursor-not-allowed" : ""
            }`}
          >
            YES
          </button>
        </div>
      </div>
    </div>
  );
}
